import { render } from "./GPricing.vue?vue&type=template&id=13dae6aa"
import script from "./GPricing.vue?vue&type=script&lang=js"
export * from "./GPricing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__